export const mockMemorials = [
  {
    id: 'm1',
    name: 'Eleanor Grace Thompson',
    birthDate: '1942-05-12',
    deathDate: '2023-11-28',
    isPrivate: false,
    notificationsEnabled: true,
    category: 'Educators',
    location: 'Willow Creek, OR',
    tagline: 'A life of love, laughter, and endless generosity. She touched the hearts of everyone she met.',
    featuredQuote: 'Kindness is the only service that will stand the test of time.',
    preferredSoundscape: 'piano',
    tributeCount: 142,
    coverImage: 'https://images.unsplash.com/photo-1465146344425-f00d5f5c8f07?q=80&w=2076&auto=format&fit=crop',
    profileImage: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?q=80&w=1288&auto=format&fit=crop',
    story: `Eleanor Grace Thompson lived a full life of service, starting her career as a primary school teacher in the rural town of Willow Creek. Over four decades, she mentored generations of students, instilling in them a love for literature and the arts.\n\nBeyond the classroom, Eleanor was a pillar of her community, organizing the annual Harvest Festival and volunteering at the local animal shelter. Her legacy lives on not just in the books she loved, but in the countless lives she shaped with her unwavering kindness.`,
    milestones: { heavenlyBirthday: '05-12', weddingAnniversary: '06-15', memorialAnniversary: '11-28' },
    donations: { goal: 5000, raised: 3250, charity: 'Willow Creek Public Library' },
    events: [
      {
        id: 'live-memorial-1',
        title: 'Celebration of Life Service',
        date: new Date(Date.now() + 3600000).toISOString(),
        type: 'Livestream',
        location: 'Willow Creek Chapel & Online',
        description: "A formal service celebrating Eleanor's impact on our community.",
      },
    ],
    timeline: [
      { year: 1942, title: 'A Star is Born', description: 'Born in the quiet town of Willow Creek, Oregon.' },
      { year: 1964, title: 'First Classroom', description: 'Began teaching at Willow Creek Elementary School.' },
      { year: 1970, title: 'Community Leader', description: 'Founded the annual Harvest Festival, a beloved tradition.' },
      { year: 2023, title: 'A Legacy Remembered', description: 'Passed peacefully, surrounded by family and friends.' },
    ],
    visitorLocations: [
      { name: 'Willow Creek, OR', coordinates: [-122.3321, 44.0521], type: 'Home', count: 42 },
      { name: 'Portland, OR', coordinates: [-122.6750, 45.5051], type: 'Family', count: 18 },
    ],
    tributes: [
      { id: 1, author: 'David Thompson', relation: 'Husband', date: '2023-11-29', message: 'My dearest Eleanor, you were my everything. The world is dimmer without your light.', gift: 'candle', giftOption: 'gold', isPrivate: false },
      { id: 2, author: 'Margaret Liu', relation: 'Former Student', date: '2023-11-30', message: 'Mrs. Thompson changed my life. She saw potential in me when I saw none.', gift: 'flower', giftOption: 'lily', isPrivate: false },
    ],
    gallery: [
      'https://images.unsplash.com/photo-1516450360452-9312f5e86fc7?q=80&w=2070&auto=format&fit=crop',
      'https://images.unsplash.com/photo-1465146344425-f00d5f5c8f07?q=80&w=2076&auto=format&fit=crop',
      'https://images.unsplash.com/photo-1499209974431-9dddcece7f88?q=80&w=2070&auto=format&fit=crop',
    ],
  },
  {
    id: 'm2',
    name: 'Marcus Aurelius Chen',
    birthDate: '1955-03-22',
    deathDate: '2022-08-14',
    isPrivate: false,
    notificationsEnabled: true,
    category: 'Veterans',
    location: 'San Francisco, CA',
    tagline: 'A decorated naval officer and devoted father who served his country with honour and grace.',
    featuredQuote: 'Duty, honour, country — and above all, family.',
    preferredSoundscape: 'nature',
    tributeCount: 89,
    coverImage: 'https://images.unsplash.com/photo-1556910103-1c02745aae4d?q=80&w=2070&auto=format&fit=crop',
    profileImage: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?q=80&w=1470&auto=format&fit=crop',
    story: `Captain Marcus Aurelius Chen served 30 years in the United States Navy, rising to the rank of Commander. A decorated veteran of two conflicts, he was known as much for his compassion as his courage.\n\nAfter retiring from service, Marcus devoted himself to mentoring young veterans and running a successful restaurant, Harbor View Bistro, which became a beloved San Francisco institution.`,
    milestones: { heavenlyBirthday: '03-22', memorialAnniversary: '08-14' },
    donations: { goal: 10000, raised: 7800, charity: 'Veterans Support Network' },
    events: [
      {
        id: 'event-m2-1',
        title: 'Annual Memorial Dinner',
        date: new Date(Date.now() + 7 * 24 * 3600000).toISOString(),
        type: 'In-Person',
        location: 'Harbor View Bistro, San Francisco',
        description: 'A fundraising dinner in honor of Captain Chen, benefiting the Veterans Support Network.',
      },
    ],
    timeline: [
      { year: 1955, title: 'Born in San Francisco', description: 'The eldest of four children in a Chinese-American family.' },
      { year: 1977, title: 'Naval Commission', description: 'Commissioned as an officer in the United States Navy.' },
      { year: 2002, title: 'Harbor View Bistro', description: 'Opened his beloved restaurant after retiring from service.' },
      { year: 2022, title: 'Final Voyage', description: 'Passed peacefully at home, surrounded by his family.' },
    ],
    visitorLocations: [
      { name: 'San Francisco, CA', coordinates: [-122.4194, 37.7749], type: 'Home', count: 55 },
    ],
    tributes: [
      { id: 1, author: 'Admiral James Reeves', relation: 'Commanding Officer', date: '2022-08-15', message: 'Marcus was the finest officer I ever served with. A true American hero.', gift: 'dove', giftOption: 'peace', isPrivate: false },
    ],
    gallery: [
      'https://images.unsplash.com/photo-1556910103-1c02745aae4d?q=80&w=2070&auto=format&fit=crop',
    ],
  },
  {
    id: 'm3',
    name: 'Maya Lin Rodriguez',
    birthDate: '1978-11-05',
    deathDate: '2024-01-20',
    isPrivate: false,
    notificationsEnabled: true,
    category: 'Artists',
    location: 'Brooklyn, NY',
    tagline: 'A visionary artist whose murals transformed Brooklyn neighborhoods and touched millions of hearts.',
    featuredQuote: 'Art is the language of the soul — speak it loudly.',
    preferredSoundscape: 'zen',
    tributeCount: 203,
    coverImage: 'https://images.unsplash.com/photo-1460661419201-fd4cecdf8a8b?q=80&w=2080&auto=format&fit=crop',
    profileImage: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?q=80&w=1287&auto=format&fit=crop',
    story: `Maya Lin Rodriguez was a celebrated muralist and community artist based in Brooklyn. Her work, spanning over 200 public murals across New York City, celebrated immigrant stories, cultural heritage, and the resilience of the human spirit.\n\nA founding member of the Brooklyn Arts Collective, Maya mentored hundreds of young artists and fought tirelessly for public art funding.`,
    milestones: { heavenlyBirthday: '11-05', memorialAnniversary: '01-20' },
    donations: { goal: 15000, raised: 12400, charity: 'Brooklyn Arts Collective' },
    events: [],
    timeline: [
      { year: 1978, title: 'Born in Brooklyn', description: 'Born to Colombian and Chinese immigrant parents.' },
      { year: 2000, title: 'First Major Mural', description: 'Created her landmark mural "Roots & Wings" in Bushwick.' },
      { year: 2015, title: 'Brooklyn Arts Collective', description: 'Co-founded the collective to support emerging artists.' },
      { year: 2024, title: 'A Canvas Left Behind', description: 'Passed after a brief illness, leaving an indelible mark on the world.' },
    ],
    visitorLocations: [
      { name: 'Brooklyn, NY', coordinates: [-73.9496, 40.6501], type: 'Home', count: 120 },
      { name: 'Bogotá, Colombia', coordinates: [-74.0721, 4.7110], type: 'Heritage', count: 35 },
    ],
    tributes: [
      { id: 1, author: 'Carlos Rodriguez', relation: 'Brother', date: '2024-01-21', message: 'Maya painted the world in colours only she could see. We are all richer for it.', gift: 'flower', giftOption: 'rose', isPrivate: false },
    ],
    gallery: [
      'https://images.unsplash.com/photo-1460661419201-fd4cecdf8a8b?q=80&w=2080&auto=format&fit=crop',
      'https://images.unsplash.com/photo-1516450360452-9312f5e86fc7?q=80&w=2070&auto=format&fit=crop',
    ],
  },
];

// Stock thresholds — shared across the app
export const STOCK_THRESHOLDS = {
  LOW: 10,       // ≤ 10 → "Low Stock" warning
  CRITICAL: 3,   // ≤ 3  → "Only X left!" critical alert
};

export const mockProducts = [
  {
    id: 'p1',
    name: 'Eternal White Lily Wreath',
    price: 150,
    originalPrice: 199,
    category: 'Flowers',
    vendor: 'Sacred Blooms',
    vendorId: 'v1',
    image: 'https://images.unsplash.com/photo-1563241527-3004b7be0ffd?q=80&w=1287&auto=format&fit=crop',
    videoUrl: 'https://www.youtube.com/watch?v=dQw4w9WgXcQ',
    stock: 3,           // CRITICAL — "Only 3 left!"
    description: 'Hand-curated white lilies arranged into an elegant memorial wreath. Delivered fresh to funeral homes worldwide.',
  },
  {
    id: 'p2',
    name: 'Heritage Oak Memory Box',
    price: 285,
    originalPrice: 350,
    category: 'Accessories',
    vendor: 'Timeless Keepsakes',
    vendorId: 'v2',
    image: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?q=80&w=1287&auto=format&fit=crop',
    videoUrl: 'https://www.youtube.com/watch?v=dQw4w9WgXcQ',
    stock: 7,           // LOW — "Low Stock · 7 left"
    description: 'A beautifully crafted solid oak memory box, engraved with the name and dates of your loved one. Holds photos, letters, and mementos.',
  },
  {
    id: 'p3',
    name: 'Celestial Cremation Urn',
    price: 420,
    category: 'Urns',
    vendor: 'Eternal Vessels',
    vendorId: 'v3',
    image: 'https://images.unsplash.com/photo-1618354691373-d851c5c3a990?q=80&w=1015&auto=format&fit=crop',
    stock: 0,           // OUT OF STOCK
    description: 'A hand-painted celestial urn crafted from biodegradable materials, perfect for a dignified and eco-conscious memorial.',
  },
  {
    id: 'p4',
    name: 'Memorial Candle Set (12)',
    price: 65,
    category: 'Accessories',
    vendor: 'Luminary Crafts',
    vendorId: 'v4',
    image: 'https://images.unsplash.com/photo-1608181831688-8a4e6f0e76d0?q=80&w=1287&auto=format&fit=crop',
    videoUrl: 'https://www.youtube.com/watch?v=dQw4w9WgXcQ',
    stock: 50,          // NORMAL — no badge
    description: 'A set of 12 hand-poured soy wax memorial candles with a gentle rose and sandalwood fragrance, perfect for vigils and ceremonies.',
  },
  {
    id: 'p5',
    name: 'Grief Companion Journal',
    price: 38,
    category: 'Services',
    vendor: 'Healing Pages',
    vendorId: 'v5',
    image: 'https://images.unsplash.com/photo-1544716278-ca5e3f4abd8c?q=80&w=1374&auto=format&fit=crop',
    stock: 100,         // NORMAL — no badge
    description: 'A beautifully designed guided journal with prompts to help process grief, preserve memories, and celebrate a life well-lived.',
  },
  {
    id: 'p6',
    name: 'Pressed Flower Memorial Frame',
    price: 120,
    category: 'Accessories',
    vendor: 'Botanical Memories',
    vendorId: 'v6',
    image: 'https://images.unsplash.com/photo-1416339306562-f3d12fefd36f?q=80&w=1287&auto=format&fit=crop',
    videoUrl: 'https://www.youtube.com/watch?v=dQw4w9WgXcQ',
    stock: 2,           // CRITICAL — "Only 2 left!"
    description: 'A handcrafted frame featuring preserved flowers from the memorial service, set in resin alongside a cherished photograph.',
  },
];

export const mockResources = [
  {
    id: 'r1',
    title: 'Navigating the First Year of Loss',
    category: 'Articles',
    description: 'A comprehensive guide on what to expect during the first 12 months of grieving.',
    readTime: '8 min read',
    image: 'https://images.unsplash.com/photo-1516589174184-c685ca33d2b0?q=80&w=2070&auto=format&fit=crop',
    tags: ['Early Grief'],
  },
  {
    id: 'r2',
    title: 'How to Talk to Children About Death',
    category: 'Articles',
    description: 'Age-appropriate ways to explain loss and help children process grief with honesty and compassion.',
    readTime: '6 min read',
    image: 'https://images.unsplash.com/photo-1491013516836-7db643ee125a?q=80&w=2025&auto=format&fit=crop',
    tags: ['Family', 'Children'],
  },
  {
    id: 'r3',
    title: 'Creating a Digital Legacy Plan',
    category: 'Articles',
    description: 'Step-by-step guidance on organizing your digital assets, passwords, and online accounts.',
    readTime: '10 min read',
    image: 'https://images.unsplash.com/photo-1507679799987-c73779587ccf?q=80&w=2071&auto=format&fit=crop',
    tags: ['Planning', 'Digital'],
  },
  {
    id: 'r4',
    title: 'Writing an Obituary with Heart',
    category: 'Articles',
    description: 'Tips and templates for crafting an obituary that truly honours a life well-lived.',
    readTime: '7 min read',
    image: 'https://images.unsplash.com/photo-1455390582262-044cdead277a?q=80&w=1973&auto=format&fit=crop',
    tags: ['Writing'],
  },
];

export const mockLiveStreams = [
  {
    id: 'live-1',
    title: 'Morning Remembrance: Sarah J. Miller',
    organizer: 'Miller Family',
    deceasedName: 'Sarah J. Miller',
    familyName: 'Miller',
    location: 'Chicago, IL',
    workPlace: 'Lakeside Elementary',
    viewers: 124,
    thumbnail: 'https://images.unsplash.com/photo-1516450360452-9312f5e86fc7?q=80&w=2070&auto=format&fit=crop',
    isLive: true,
    platform: 'internal',
    description: 'An intimate gathering to celebrate the vibrant life of Sarah J. Miller.',
  },
  {
    id: 'live-2',
    title: 'Commemorative Service: Robert Chen',
    organizer: 'Chen Estate',
    deceasedName: 'Robert Chen',
    familyName: 'Chen',
    location: 'San Francisco, CA',
    workPlace: 'Harbor View Bistro',
    viewers: 89,
    thumbnail: 'https://images.unsplash.com/photo-1556910103-1c02745aae4d?q=80&w=2070&auto=format&fit=crop',
    isLive: true,
    platform: 'youtube',
    embedId: 'dQw4w9WgXcQ',
    description: 'Joining from San Francisco to honor the legacy of Chef Robert Chen.',
  },
  {
    id: 'live-3',
    title: 'Evening Vigil: Eleanor Thompson',
    organizer: 'Thompson Family',
    deceasedName: 'Eleanor Thompson',
    familyName: 'Thompson',
    location: 'Willow Creek, OR',
    workPlace: 'Public Library',
    viewers: 256,
    thumbnail: 'https://images.unsplash.com/photo-1465146344425-f00d5f5c8f07?q=80&w=2076&auto=format&fit=crop',
    isLive: true,
    platform: 'facebook',
    streamUrl: 'https://www.facebook.com/facebook/videos/10153231339981729/',
    description: 'A community-led candle lighting vigil for our beloved Mrs. Thompson.',
  },
  {
    id: 'live-4',
    title: "Artist's Tribute: Maya Lin",
    organizer: 'Brooklyn Arts Collective',
    deceasedName: 'Maya Lin',
    familyName: 'Lin',
    location: 'Brooklyn, NY',
    workPlace: 'Vanguard Arts Hub',
    viewers: 412,
    thumbnail: 'https://images.unsplash.com/photo-1460661419201-fd4cecdf8a8b?q=80&w=2080&auto=format&fit=crop',
    isLive: true,
    platform: 'instagram',
    username: 'eternal_memories_art',
    description: 'Live painting and storytelling in memory of Maya Lin.',
  },
];